import { useState, useEffect } from "react";
import { observer, inject } from "mobx-react";
import LoadingContainer from "../layouts/LoadingContainer";
import { Outlet } from "react-router-dom";
import Header from "../layouts/Header";
import SideBar from "../layouts/SideBar";
import { useTranslation } from "react-i18next";
import { ScrollDiv } from "../components/Common";
import { BottomDrawer } from "../components/BottomDrawer";
import { Role } from "../stores/userStore";
import { useMobile } from "../utils/mobile";
import MobileHeader from "../layouts/MobileHeader";
import MobileDrawer from "./MobileDrawer";
import addSquareImg from "../assets/img/add-square.svg";
import NewApply from "../layouts/NewApply";
import { useTheme } from "styled-components";
import { useLocation } from "react-router-dom";

const Tenant = ({ userStore, tenantsStore }) => {
  const [isLoading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const [title, setTitle] = useState(t("menu:lobby"));
  const [departments, setDepartments] = useState([]);
  const [showDepratmentsMenu, setShowDepratmentsMenu] = useState(false);
  const theme = useTheme();
  const location = useLocation();

  const isMobile = useMobile();

  useEffect(() => {
    const fetchSaleContracts = async () => {
      setLoading(true);
      tenantsStore.setError("");

      if (
        !tenantsStore.selectedSiteSpace?.SPACENAME &&
        userStore.userDetails.ALL_TENANT_SPACES?.length > 0
      ) {
        await tenantsStore.setSelectedSiteSpace(
          userStore.userDetails.ALL_TENANT_SPACES[0]
        );
      }
      const data = {
        MAINCUST: userStore.userDetails.MAINCUST,
        CUST: userStore.userDetails.CUST,
        MAINENV: userStore.userDetails.MAINENV,
        CUSTNAME: tenantsStore.selectedSiteSpace.CUSTNAME,
        USERNAME: userStore.userDetails.USERNAME,
        CELLPHONE: userStore.userDetails.CELLPHONE,
        DNAME: tenantsStore.selectedSiteSpace?.DNAME || tenantsStore.selectedContract?.DNAME,
      };
      await tenantsStore.getSaleContracts(data);
      let contract = null;
      if (tenantsStore.contracts?.length > 0) {
        contract = tenantsStore.contracts?.find(
          (cont) =>
            cont?.SPACENAME === tenantsStore.selectedSiteSpace?.SPACENAME &&
            cont?.ENV === tenantsStore.selectedSiteSpace?.DNAME
        );
        if (!!contract) {
          const projData = {
            MAINCUST: userStore.userDetails.MAINCUST,
            CUST: userStore.userDetails.CUST,
            MAINENV: userStore.userDetails.MAINENV,
            CUSTNAME: userStore.userDetails.CUSTNAME,
            SITEID: contract?.SITEID,
            BUILDINGNUM: contract?.BUILDINGNUM,
            CONTNAME: contract?.CONTNAME,
            DNAME: contract?.DNAME || contract?.ENV,
          };
          await tenantsStore.getSaleContract(projData);
        }
      }


      const selected =
        !!tenantsStore.selectedContract || !!contract?.CONT
          ? tenantsStore.selectedContract || contract
          : tenantsStore.contracts?.length > 0 ? tenantsStore.contracts[0] : null;

      if (tenantsStore.sites?.length === 0) {
        await tenantsStore.getCustomerSites(data);
      }
      if (selected) {
        const project = tenantsStore.sites?.find(
          (s) => s.SITENUM === selected?.SITENUM && s.DNAME === selected?.DNAME
        );



        tenantsStore.setSelectedContract({
          ...selected,
          SITE: project?.SITE,
          SITEID: project?.SITEID,
          DNAME: project?.DNAME,
        });

        if (!!tenantsStore.selectedContract?.CONT || !!contract?.CONT) {
          const selectedProjData = {
            MAINCUST: userStore.userDetails.MAINCUST,
            CUST: userStore.userDetails.CUST,
            MAINENV: userStore.userDetails.MAINENV,
            CUSTNAME: userStore.userDetails.CUSTNAME,
            SITEID: project?.SITEID,
            BUILDINGNUM: contract?.BUILDINGNUM,
            DNAME: project?.DNAME,
          };

          tenantsStore.getProjectImage(selectedProjData);
          const departments = await tenantsStore.getDepartments(
            selectedProjData
          );
          setDepartments(departments || []);
        }
      }

      setLoading(false);
    };
    fetchSaleContracts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedSiteSpace]);

  useEffect(() => {
    const getData = async () => {
      const selectedMessage = tenantsStore.selectedContract
        ?.ZCOM_TENANTMESSAGES_SUBFORM?.length
        ? tenantsStore.selectedContract?.ZCOM_TENANTMESSAGES_SUBFORM[0]
        : undefined;
      const selectedDoc =
        tenantsStore.selectedContract?.EXTFILES_SUBFORM?.filter(
          (ext) => ext.SUFFIX === "pdf"
        )?.length
          ? tenantsStore.selectedContract?.EXTFILES_SUBFORM?.filter(
            (ext) => ext.SUFFIX === "pdf"
          )[0]
          : undefined;
      tenantsStore.setSelectedDoc(selectedDoc);
      tenantsStore.setSelectedMessage(selectedMessage);
    };

    if (
      !!tenantsStore.selectedContract?.CONT &&
      tenantsStore.selectedContract.SITEID
    ) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantsStore.selectedContract]);

  return (
    <div
      style={{
        height: "100vh",
      }}
    >
      <LoadingContainer isLoading={isLoading}>
        {isMobile && (
          <MobileHeader
            name={userStore.userDetails.NAME}
            title={title}
            admin={userStore.userDetails.role === Role.Admin}
          />
        )}
        {!isMobile ? (
          <SideBar
            logo={userStore.userDetails.LOGO}
            setTitle={setTitle}
            departments={departments?.filter((d) =>
              tenantsStore.selectedSiteSpace?.ISONLYCONTSALE === "Y"
                ? d.BEDEKFLAG !== "Y"
                : true
            )}
          >
            <Header
              name={userStore.userDetails.NAME}
              title={title}
              admin={userStore.userDetails.role === Role.Admin}
            />
            <ScrollDiv maxHeight={"calc(100vh - 84px)"}>
              <Outlet />
            </ScrollDiv>
          </SideBar>
        ) : (
          <div>
            <MobileDrawer
              setTitle={setTitle}
              departments={departments?.filter((d) =>
                tenantsStore.selectedSiteSpace?.ISONLYCONTSALE === "Y"
                  ? d.BEDEKFLAG !== "Y"
                  : true
              )}
            >
              <Outlet />
              {location.pathname.includes("/lobby") && (
                <NewApply
                  isMobile={true}
                  backgroundColor={theme.color.green}
                  style={{
                    flex: 1,
                    justifyContent: "end",
                    alignSelf: "center",
                    position: "absolute",
                    left: isRtl ? 20 : "unset",
                    right: isRtl ? "unset" : 20,
                    bottom: 30,
                    zIndex: 999,
                  }}
                  setTitle={setTitle}
                  img={addSquareImg}
                  onItemClicked={() => {
                    setShowDepratmentsMenu(!showDepratmentsMenu);
                  }}
                />
              )}
              {showDepratmentsMenu && (
                <BottomDrawer
                  items={departments}
                  setShow={setShowDepratmentsMenu}
                  show={showDepratmentsMenu}
                />
              )}
            </MobileDrawer>
          </div>
        )}
      </LoadingContainer>
    </div>
  );
};

export default inject("userStore", "tenantsStore")(observer(Tenant));
